import { createContext, useContext } from 'react';

/**
 * The desktop sidebar is an icon rail that expands while the pointer or keyboard focus is in it.
 * A menu it opens (organisation, theme, profile) renders in a portal, so the pointer leaves the
 * sidebar the moment it enters the menu: each menu calls `hold(true)` while open so the sidebar
 * stays expanded under it, and `hold(false)` when it closes.
 */
export const SidebarHoldContext = createContext<(open: boolean) => void>(() => undefined);

export const useSidebarHold = () => useContext(SidebarHoldContext);
